import { css, CSSProp } from 'styled-components';
import { breakpoints } from '@config';

export const laptop= (inner: CSSProp) => css`
  @media (min-width: ${breakpoints.laptop}) {
    ${inner};
  }
`;

export const desktop= (inner: CSSProp) => css`
  @media (min-width: ${breakpoints.desktop}) {
    ${inner};
  }
`;